module.exports = __webpack_public_path__ + "static/img/son4_active.69d0dfe5.png";